import { Box, Typography } from "@mui/material";
import React from "react";

import { ReactComponent as PodcastIcon } from "../../static/svg/old-podcast-icon.svg";
import LatestPodcast from "./LatestPodcast";

type Props = {};

const LandingPodcast = (props: Props) => {
  return (
    <React.Fragment>
      <Box px={{ xs: 4, sm: 5, md: 10 }} py={{ xs: 2, sm: 4 }}>
        <Box>
          <PodcastIcon className="mx-auto" />
          <Box display="flex" justifyContent="center" py={3}>
            <Typography
              variant="caption"
              fontSize={{ xs: "11px", sm: "10px", md: "12px" }}
              lineHeight={{ xs: "80%", sm: "189%" }}
              letterSpacing={"0.1em"}
              className="text-center mx-auto "
            >
              Podcasts
            </Typography>
          </Box>
        </Box>

        <LatestPodcast />
      </Box>
    </React.Fragment>
  );
};

export default LandingPodcast;
